import { produce } from 'immer';
import { AppState } from './interface';
import { Actions } from './action';
import { AppAction } from './enum';
import { TokenState, Views } from '../../enum';

export const initialState: AppState = {
    activeView: Views.FORM,
    isLoading: false,
    isOverlayOpen: false,
    isOverlayLoaded: false,
    ffTokenState: TokenState.UNKNOWN,
};

const appReducer = (state = initialState, action: Actions) => {
    return produce(state, (draftState) => {
        switch (action.type) {
            case AppAction.SET_LOADING:
                draftState.isLoading = action.isLoading;
                break;
            case AppAction.SET_ACTIVE_VIEW:
                draftState.activeView = action.activeView;
                break;
            case AppAction.TOGGLE_OVERLAY:
                draftState.isOverlayOpen = action.shouldOpen;
                break;
            case AppAction.SET_OVERLAY_LOADED:
                draftState.isOverlayLoaded = action.isLoaded;
                break;
            case AppAction.SET_TOKEN_STATE:
                draftState.ffTokenState = action.ffTokenState;
                break;
        }
    });
};

export default appReducer;
